
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EditorState } from '@/types/editor';

@Component
export default class TwitterPreview extends Vue {
  @Prop() content!: EditorState;
  @Prop() showCrop!: boolean;

  crops: object = [
    { text: 'Standard', value: '' },
    { text: 'Fit', value: 'fit-in' },
    { text: 'Smart', value: 'smart' },
  ];

  get imageExists(): boolean {
    return this.content.meta!.image !== null;
  }

  get imageUrl(): string {
    let imagePath = process.env.VUE_APP_DEFAULT_FEATURED_IMAGE;
    const fit =
      this.content.meta!.twitter_image_crop === 'fit-in' ? 'fit-in/' : '';
    const smart =
      this.content.meta!.twitter_image_crop === 'smart' ? 'smart/' : '';
    if (this.content.meta !== null) {
      if (this.imageExists) {
        imagePath = this.content.meta!.image!.path.replace(
          'https://cdn.alternativebusinessfunding.co.uk/',
          '',
        );
      }
    }
    return `https://cdn.alternativebusinessfunding.co.uk/${fit}504x252/${smart}${imagePath}`;
  }

  get title() {
    return this.content.meta!.twitter_title !== null
      ? this.content.meta!.twitter_title
      : this.content.meta!.meta_title !== null
        ? this.content.meta!.meta_title
        : this.content.meta!.title;
  }

  get description() {
    return this.content.meta!.twitter_description !== null
      ? this.content.meta!.twitter_description
      : this.content.meta!.meta_description !== null
        ? this.content.meta!.meta_description
        : this.content.summary;
  }
}
